/* ==========================================================================
   UVCeed Vertical Landing Pages - shared behavior
   Loaded (deferred) from theme.liquid when template contains 'for-'.
   Handles: scroll reveal, FAQ accordion, AJAX add-to-cart, GA4/Meta events.
   Event taxonomy follows the PRD (Section 8).
   ========================================================================== */
(function () {
  'use strict';

  /* --- Analytics helpers ------------------------------------------------- */
  function vertical() {
    var el = document.querySelector('[data-vertical]');
    return (el && el.getAttribute('data-vertical')) || 'unknown';
  }

  function track(eventName, params) {
    var payload = params || {};
    try {
      if (window.gtag) { window.gtag('event', eventName, payload); }
    } catch (e) {}
    try {
      if (window.fbq) { window.fbq('trackCustom', eventName, payload); }
    } catch (e) {}
  }

  /* --- Scroll reveal ----------------------------------------------------- */
  function initReveal() {
    var items = document.querySelectorAll('.vp-reveal');
    if (!items.length || !('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    var vh = window.innerHeight || document.documentElement.clientHeight;
    items.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      // Elements already on screen at load stay visible (no flash of hidden
      // content). Off-screen elements are armed, then revealed on scroll.
      if (rect.top < vh && rect.bottom > 0) {
        el.classList.add('is-visible');
      } else {
        el.classList.add('vp-reveal--armed');
        io.observe(el);
      }
    });
  }

  /* --- AJAX add-to-cart -------------------------------------------------- */
  function flashButton(btn, html, ms) {
    if (!btn) { return; }
    var original = btn.dataset.originalHtml || btn.innerHTML;
    btn.dataset.originalHtml = original;
    btn.innerHTML = html;
    window.setTimeout(function () {
      btn.innerHTML = original;
      btn.disabled = false;
    }, ms || 1800);
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function openCart() {
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
    } else if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
      if (typeof window.cartDrawer.refreshCart === 'function') { window.cartDrawer.refreshCart(); }
      window.cartDrawer.open();
    } else {
      document.dispatchEvent(new CustomEvent('cart:open'));
    }
  }

  function initAddToCart() {
    document.querySelectorAll('form[data-vertical-cart]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var btn = form.querySelector('button[type="submit"]');
        var idInput = form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value) {
          window.alert('This product is currently unavailable.');
          return;
        }
        if (btn) {
          btn.disabled = true;
          btn.dataset.originalHtml = btn.innerHTML;
          btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Adding...';
        }

        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) {
            if (!r.ok) { throw new Error('add_failed'); }
            return r.json();
          })
          .then(function (data) {
            track('add_to_cart_' + vertical(), {
              vertical: vertical(),
              currency: 'USD',
              value: (data.final_price || data.price || 0) / 100,
              items: [{
                item_id: data.variant_id,
                item_name: data.product_title,
                price: (data.final_price || data.price || 0) / 100,
                quantity: 1
              }]
            });
            try {
              if (window.fbq) {
                window.fbq('track', 'AddToCart', {
                  content_ids: [data.variant_id],
                  content_name: data.product_title,
                  content_type: 'product',
                  value: (data.final_price || data.price || 0) / 100,
                  currency: 'USD'
                });
              }
            } catch (e) {}
            refreshCartCount();
            flashButton(btn, '<i class="fas fa-check"></i> Added to Cart', 1600);
            window.setTimeout(openCart, 350);
          })
          .catch(function () {
            flashButton(btn, '<i class="fas fa-exclamation-triangle"></i> Try Again', 2200);
          });
      });
    });
  }

  /* --- Click + view tracking -------------------------------------------- */
  function initTracking() {
    document.querySelectorAll('[data-vp-cta]').forEach(function (el) {
      el.addEventListener('click', function () {
        track('hero_cta_click_' + vertical(), {
          vertical: vertical(),
          label: el.getAttribute('data-vp-cta')
        });
      });
    });

    document.querySelectorAll('[data-vp-product]').forEach(function (el) {
      el.addEventListener('click', function () {
        track('product_card_click_' + vertical(), {
          vertical: vertical(),
          product_id: el.getAttribute('data-vp-product')
        });
      });
    });

    var table = document.querySelector('.vp-compare');
    if (table && 'IntersectionObserver' in window) {
      var tableIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            track('comparison_table_view_' + vertical(), { vertical: vertical() });
            tableIO.disconnect();
          }
        });
      }, { threshold: 0.4 });
      tableIO.observe(table);
    }

    // page_view fires once the deferred script runs.
    track('page_view_vertical_' + vertical(), { vertical: vertical() });
  }

  /* --- Boot -------------------------------------------------------------- */
  function init() {
    initReveal();
    initAddToCart();
    initTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
